import React, { createContext, useContext } from 'react';

interface TabContextType {
  tabActive: string;
  toggle: (tabId: string) => void;
}

const TabContext = createContext<TabContextType>({} as TabContextType);

export const useTabContext = () => {
  return useContext(TabContext);
};

export default TabContext;
